import React, { useState } from 'react';
import { compose } from 'redux';

import InputText from '../InputText';
import { Row } from '../../Structure';

import { withMailingAddressActions } from '../../../hocs/withActions';
import { withScreenData, withShouldSubmit } from '../../../hocs/withData';

const CompanyAddressForm = ({
  mailingAddressData = {},
  onMailingDataUpdate,
  required = false,
}) => {
  const [values, setValues] = useState(mailingAddressData);

  const updateField = (event) => {
    const { name, value } = event;
    values[name] = value;
    setValues({ ...values });
    onMailingDataUpdate(values);
  };
  return (
    <div className="form-content">
      <Row>
        <InputText
          name="mailingAddressLine1"
          labelTitle="Address Line 1*"
          required={required}
          value={values.mailingAddressLine1}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="mailingAddressLine2"
          labelTitle="Address Line 2*"
          required={required}
          value={values.mailingAddressLine2}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="mailingAddressLine3"
          labelTitle="Address Line 3*"
          required={required}
          value={values.mailingAddressLine3}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="mailingAddressLine4"
          labelTitle="Address Line 4"
          value={values.mailingAddressLine4}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="mailingPostcode"
          labelTitle="Postcode*"
          required={required}
          value={values.mailingPostcode}
          onChange={updateField}
        />
      </Row>
    </div>
  );
};

export default compose(
  withMailingAddressActions,
  withScreenData,
  withShouldSubmit,
)(CompanyAddressForm);
